export enum TaskType {
  Import = 0,
  Timesheet = 1,
  Printout = 2,
  Violation = 3,
  SaveImport = 4,
  ImiExport = 5,
  BusinessTrip = 6,
  // Eksport CSV - liczony w FileProcessorze, jak wydruki.
  Export = 7,
}
